export default () => {
	const nuxtApp = useNuxtApp()

	return {
		directus: nuxtApp.$directus,
		createItem: nuxtApp.$createItem,
		readItem: nuxtApp.$readItem,
		readItems: nuxtApp.$readItems,
		readCollection: nuxtApp.$readCollection,
		readSingleton: nuxtApp.$readSingleton,
	}
}
